import React from 'react';
import { useReveal } from '../lib/useReveal';
export function ProblemSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-136">
      <div className="container mx-auto max-w-3xl" data-id="element-137">
        <div ref={ref1} className={`reveal ${vis1 ? 'is-visible' : ''}`} data-id="element-138">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight text-[#eab308] text-center" data-id="element-139">
            ¿Sentís que hacés todo bien… pero algo siempre vuelve?
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-gray-300 leading-relaxed" data-id="element-140">
            <p className="text-center" data-id="element-141">
              Dietas, terapias, meditaciones, libros de autoayuda.
            </p>

            <p className="text-center" data-id="element-142">
              Y sin embargo, el mismo dolor regresa. La misma situación se
              repite. El mismo bloqueo aparece una y otra vez.
            </p>

            <p className="text-center font-medium text-white" data-id="element-143">
              No es casualidad. Y definitivamente no es tu culpa.
            </p>

            <div className="my-10 p-6 md:p-8 bg-[#111111] border-l-4 border-[#eab308] rounded-r-2xl shadow-lg" data-id="element-144">
              <p className="text-xl md:text-2xl font-medium text-gray-200 leading-snug" data-id="element-145">
                Lo que nadie te dijo es que tu cuerpo guarda un registro exacto
                de todo lo que viviste. Cada miedo no procesado. Cada emoción
                que tragaste. Cada trauma que "ya superaste" pero que sigue ahí,
                dando forma a tu salud, tus relaciones y tu dinero.
              </p>
            </div>

            <p className="text-[#eab308] font-bold text-xl md:text-2xl text-center" data-id="element-146">
              Eso es lo que estudia la BIODECODIFICACION.
            </p>
          </div>
        </div>
      </div>
    </section>;
}